/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'camera-create': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M15 3v2h-5c-.087 0-.36.282-.812 1.022-.029.047-.237.391-.3.492a8.38 8.38 0 01-.327.5C8.112 7.635 7.664 8 7 8H4a1 1 0 00-1 1v9a1 1 0 001 1h16a1 1 0 001-1v-6h2v6a3 3 0 01-3 3H4a3 3 0 01-3-3V9a3 3 0 013-3h2.816c.033-.038.074-.09.121-.155.07-.098.15-.219.25-.381l.295-.486C8.31 3.622 8.913 3 10 3h5zm6 1v2h2v2h-2v2h-2V8h-2V6h2V4h2zm-9 14a5 5 0 110-10 5 5 0 010 10zm0-2a3 3 0 100-6 3 3 0 000 6z" _fill="#7CAACF" fill-rule="evenodd"/>'
  }
})
